export const base64toBlob = (base64: string, contentType: string): Blob => {
  const base64Content: string = base64.split('base64,')[1];
  const binaryString: string = atob(base64Content);
  const byteArrays: Array<any> = [];

  for (let offset = 0; offset < binaryString.length; offset += 512) {
    const slice = binaryString.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);

    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
};
